import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 生成购物车条目唯一 key（相同餐品不同规格视为不同条目）
function specKey(item) {
  return `${item.dishId}_${item.specIce || ''}_${item.specSugar || ''}_${item.specTemp || ''}`
}

export default new Vuex.Store({
  state: {
    tableNo: '',       // 当前桌号
    tableName: '',
    cart: []           // [{dishId, dishName, dishImage, price, quantity, specIce, specSugar, specTemp, _key}]
  },
  getters: {
    cartTotal: state => state.cart.reduce((sum, item) => sum + item.price * item.quantity, 0),
    cartCount: state => state.cart.reduce((sum, item) => sum + item.quantity, 0)
  },
  mutations: {
    SET_TABLE(state, { tableNo, tableName }) {
      state.tableNo = tableNo
      state.tableName = tableName
    },
    ADD_TO_CART(state, dish) {
      const key = specKey(dish)
      const found = state.cart.find(i => i._key === key)
      if (found) {
        found.quantity++
      } else {
        state.cart.push({ ...dish, quantity: 1, _key: key })
      }
    },
    REMOVE_FROM_CART(state, key) {
      const idx = state.cart.findIndex(i => i._key === key)
      if (idx !== -1) {
        if (state.cart[idx].quantity > 1) {
          state.cart[idx].quantity--
        } else {
          state.cart.splice(idx, 1)
        }
      }
    },
    CLEAR_CART(state) {
      state.cart = []
    }
  }
})
